import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { SnackbarService } from './snackbar.service';
import { SnackbarEvent } from './snackbar.model';

@Component({
    selector: 'app-snackbar-container',
    standalone: true,
    template: ''
})
export class ShSnackbarContainerComponent implements OnInit {
    private readonly snackbarService = inject(SnackbarService);
    private readonly destroyRef = inject(DestroyRef);

    private activeSnackbar: HTMLElement | null = null;

    public ngOnInit(): void {
        this.listenForSnackbarEvents();
    }

    private listenForSnackbarEvents(): void {
        this.snackbarService.snackbar$
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap((event) => {
                    if (event.visible) {
                        this.show(event);
                    } else {
                        this.removeActiveSnackbar();
                    }
                })
            )
            .subscribe();
    }

    private show(event: SnackbarEvent): void {
        // Remove any existing snackbar first
        this.removeActiveSnackbar();

        const el = document.createElement('sh-snackbar');
        el.setAttribute('label', event.label);
        if (event.type) el.setAttribute('type', event.type);
        el.setAttribute('position', event.position ?? 'top-center');
        el.setAttribute('timeout', String(event.timeout ?? 4000));
        if (event.dismissible) el.setAttribute('dismissible', '');
        if (event.actionLabel) el.setAttribute('action-label', event.actionLabel);
        el.setAttribute('accessible-close-label', 'Close notification');

        el.addEventListener('dismissed', () => this.removeActiveSnackbar());
        el.addEventListener('action-clicked', () => this.snackbarService.emitActionClicked());

        document.body.appendChild(el);
        this.activeSnackbar = el;
    }

    private removeActiveSnackbar(): void {
        if (this.activeSnackbar) {
            this.activeSnackbar.remove();
            this.activeSnackbar = null;
        }
    }
}
